import { programRequestsApi } from '../api/programRequestsApi';
import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditNewProgramRequest } from './newProgramModel';

export const editNewProgramFlow = ({
    form,
    files,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditNewProgramRequest(form, details),
        files,
        onError,
        updateRequest: api.updateNewProgram,
        uploadFiles: api.uploadFiles,
    });
